// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2HrDT","requiredAsterisk":"Info_requiredAsterisk__ERvAw"};